import { Component, OnInit, ViewChild } from '@angular/core';
import { NavService } from '../../_services/_nav.service';
import { BusquedaFiltros } from '../../_models/busqueda-filtros';
import { Table } from 'primeng/table';
import { CalendarioPropiedades } from '../../_models/calendario-propiedades';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ConfirmationService, SelectItem } from 'primeng/api';
import { TerceroService } from '../../_services/tercero.service';
import { Tercero } from '../../_models/tercero';
import { EstructuraFisicaService } from '../../_services/estructura-fisica.service';
import { ConstanteService } from '../../_services/constante.service';
import { AppSettings } from '../../../proyect.conf';
import { AutenticacionService } from '../../_services/autenticacion.service';
import { ListaItem } from '../../_models/lista-item';
import { ListaService } from '../../_services/lista.service';
import { SolicitudEstadoHistorico } from '../../_models/solicitud-estado-historico';
import { ProductoEstadoRelacionService } from '../../_services/producto-estado-relacion.service';
import { ProductoEstadoRelacionCausalService } from '../../_services/producto-estado-relacion-causal.service';
import { SolicitudEstadoHistoricoService } from '../../_services/solicitud-estado-historico.service';
import { ProductoEstadoRelacion } from '../../_models/producto-estado-relacion';
import { SolicitudService } from '../../_services/solicitud.service';
import { ZonaService } from '../../_services/zona.service';
import { SolicitudBloqueoSarlaftService } from '../../_services/solicitud-bloqueo-sarlaft.service';
import { SolicitudUcDesbloqueo } from '../../_models/solicitud-uc-desbloqueo';
import { SolicitudUcDesbloqueoService } from '../../_services/solicitud-uc-desbloqueo.service';
import { SolicitudUnidadCreditoService } from '../../_services/solicitud-unidad-credito.service';
import { forkJoin } from 'rxjs';
import { Integraciones } from '../../_enums/enum';
import { CentralRiesgoIntegracion } from '../../_models/central-riesgo-integracion';
import { ProductoControlService } from '../../_services/producto-control.service';
import { CentralRiesgoIntegracionService } from '../../_services/central-riesgo-integracion.service';
import { SolicitudUcBloqueoService } from '../../_services/solicitud-uc-bloqueo.service';
import { IntegracionValidatorService } from '../../utils/integracion-validator.service';
import { PoliticasCreditoService } from '../../_services/politicas-credito.service';
import { AdjuntoService } from '../../_services/adjunto.service';
import { DomSanitizer } from '@angular/platform-browser';

@Component( {
  selector: 'app-solicitud-bloqueo-sarlaft-listado',
  templateUrl: 'solicitud-bloqueo-sarlaft-listado.component.html'
} )

export class SolicitudBloqueoSarlaftListadoComponent implements OnInit {

  @ViewChild('dt') tabla: Table;

  // MOCK OBJECTS
  public lista = [
    {
      numeroSolicitud: 1,
      codigoShivam: 'CM150000',
      numeroDocumento: 123456789,
      nombreCliente: 'JOSE ARIAS',
      nombreOficina: 'RIONEGRO',
      fechaSolicitud: '2019-10-25',
      idSolicitud: 725,
      indicadorHabilitado: true,
      idProducto: 1,
      idEstado: 48
    },
    {
      numeroSolicitud: 2,
      codigoShivam: 'CM160000',
      numeroDocumento: 987654321,
      nombreCliente: 'CAMILA CARDENAS',
      nombreOficina: 'SANTANDER',
      fechaSolicitud: '2019-11-02',
      idSolicitud: 726,
      indicadorHabilitado: true,
      idProducto: 1,
      idEstado: 48
    },
    {
      numeroSolicitud: 3,
      codigoShivam: 'CM170000',
      numeroDocumento: 123459876,
      nombreCliente: 'GERARDO TORRES',
      nombreOficina: 'VALLE DEL CAUCA',
      fechaSolicitud: '2019-11-15',
      idSolicitud: 727,
      indicadorHabilitado: true,
      idProducto: 1,
      idEstado: 48
    },

  ];

  public unidadesCredito = [
    {
      idSolicitudUnidadCredito: '851',
      idSolicitud: 725,
      nombreCompleto: 'SERGIO MAURICIO MANTILLA SERRANO',
      idTercero: 44,
      idProducto: 1,
      numeroDocumento: 1095923251,
      indicadorHabilitado: true,
      tipoDocumento: 'Cedula de Ciudadania',
      idAdjunto: null,
      nomArchivo: null,
      tipoVinculacion: 'Titular',
      observacion: null
    },
    {
      idSolicitudUnidadCredito: '851',
      idSolicitud: 725,
      nombreCompleto: 'FERNANDO JOSE ARAUJO SIERRA',
      idTercero: 44,
      idProducto: 1,
      numeroDocumento: 1095923251,
      indicadorHabilitado: true,
      tipoDocumento: 'Cedula de Ciudadania',
      idAdjunto: null,
      nomArchivo: null,
      tipoVinculacion: 'Codeudor',
      observacion: null
    },
  ];

  public cargaInicial: boolean = true;
  public errorConfiguracion = false;
  public mensajeError: string;

  // Variables del datatable
  public numRegistros: number = null;
  public buscando: boolean = false;
  public columnas: any[] = [];
  public listaSolicitudesBloqueo: any[] = [];

  // Buscador
  public busqueda: string;
  public listaOficinas: SelectItem[] = [];
  public listaTerceros: Tercero[] = [];
  formBusqueda: FormGroup;
  public submittedBusqueda: boolean = false;

  // Paginacion
  page = '0';
  rowsPerPage = 10;
  rowsCount = 10;

  // Configuracion calendar
  maxFecha: Date;
  calendarProperties: CalendarioPropiedades = new CalendarioPropiedades();

  get f() {
    return this.formBusqueda.controls;
  }

  // Variables gestion bloqueo sarlaft
  public continuandoProceso: boolean = false;

  //  Modal Continuar proceso
  public formContinuarProcesoSarlaft = {
    listaUnidadesCredito: [],
    idSolicitud: null,
    submittedContinuarProceso: false,
    showDlgContinuarProceso: false,
    uploadingFile: false
  };

  public formDenegarSolicitud: FormGroup;
  public showDlgDenegar: boolean = false;
  public denegarSubmitted: boolean = false;
  public listaCausalesSolicitud: SelectItem[] = [];
  public lstProductoEstado: any[] = [];

  public fsize = 50000000;
  public ftype = '';
  public svcThUrl = AppSettings.rutServiciosADJ + '/api/adjuntos';
  public loadingCausalDlg: boolean = false;
  public savingCausal: boolean = false;
  private solicitudContinuaProceso = null;
  private solicitudHistorico: SolicitudEstadoHistorico;
  private solicitudHistoricos: SolicitudEstadoHistorico[] = [];
  public cargandoInfoSolicitud: boolean = false;

  get fD() {
    return this.formDenegarSolicitud.controls;
  }

  sarlaft: CentralRiesgoIntegracion;
  listasRestrictivas: CentralRiesgoIntegracion;
  preselecta: CentralRiesgoIntegracion;
  solUcBloqueo: any;

  constructor( private navService: NavService,
               private fb: FormBuilder,
               private officeService: EstructuraFisicaService,
               private terceroService: TerceroService,
               private confirmService: ConfirmationService,
               private constanteService: ConstanteService,
               private authService: AutenticacionService,
               private lisServicio: ListaService,
               private proEstadoRelacionServicio: ProductoEstadoRelacionService,
               private solEstadoHistoricoService: SolicitudEstadoHistoricoService,
               private solicitudService: SolicitudService,
               private zonaService: ZonaService,
               private proEstadoRelacionCausalServicio: ProductoEstadoRelacionCausalService,
               private solBloqueoSarlaftService: SolicitudBloqueoSarlaftService,
               private solUcDesbloqueoSarlaftService: SolicitudUcDesbloqueoService,
               private solUcService: SolicitudUnidadCreditoService,
               private cenRiesgoIntegracionServicio: CentralRiesgoIntegracionService,
               private solUcBloqueoService: SolicitudUcBloqueoService,
               private intValidatorService: IntegracionValidatorService,
               private politicaCreditoService: PoliticasCreditoService,
               private adjServicio: AdjuntoService,
               private sanitizer: DomSanitizer ) {

    this.setFormBusqueda();
    this.setFormDenegar();
    this.obtenerFiltros();
    // this.getListas();
    this.getOficinasZonas();

    this.constanteService.getByCode( 'FTYPE' ).subscribe( data => {
      if ( data && data.valor ) {
        this.ftype = data.valor;
      }
    } );
    this.constanteService.getByCode( 'FSIZE' ).subscribe( data => {
      if ( data && data.valor ) {
        this.fsize = Number( data.valor );
      }
    } );
  }

  ngOnInit(): void {
    this.maxFecha = new Date();
    this.inicializarTabla();
    this.calendarProperties.actualizarRango( 3 );
    this.getIndicadoresIntegraciones();
  }

  private inicializarTabla() {

    this.columnas = [
      /*{ field: 'numeroSolicitud', header: this.navService.buscarMensaje( 'SOLICITUDBLOQUEOSARLAFT.LBL_NUMEROSOLICITUD' ), sort: false },*/
      { field: 'codigoShivam', header: this.navService.buscarMensaje( 'SOLICITUDBLOQUEOSARLAFT.LBL_CODIGOSHIVAM' ), sort: false },
      { field: 'numeroDocumento', header: this.navService.buscarMensaje( 'SOLICITUDBLOQUEOSARLAFT.LBL_NUMERODOCUMENTO' ), sort: false },
      { field: 'nombreCliente', header: this.navService.buscarMensaje( 'SOLICITUDBLOQUEOSARLAFT.LBL_NOMBRECLIENTE' ), sort: false },
      { field: 'nombreOficina', header: this.navService.buscarMensaje( 'SOLICITUDBLOQUEOSARLAFT.LBL_NOMBREOFICINA' ), sort: false },
      { field: 'fechaSolicitud', header: this.navService.buscarMensaje( 'SOLICITUDBLOQUEOSARLAFT.LBL_FECHASOLICITUD' ), sort: false },
      { field: 'acciones', header: this.navService.buscarMensaje( 'SOLICITUDBLOQUEOSARLAFT.LBL_ACCIONES' ), sort: false }
    ];
  }

  private getIndicadoresIntegraciones() {
    forkJoin(
      this.cenRiesgoIntegracionServicio.obtenerPorCodigo( Integraciones.SARLAFT_OBTENER_PERSONA_NATURAL ),
      this.cenRiesgoIntegracionServicio.obtenerPorCodigo( Integraciones.LISTARESTRICTIVA ),
      this.cenRiesgoIntegracionServicio.obtenerPorCodigo( Integraciones.PRESELECTA )
    ).subscribe( ( [ sarlaftInt, lrInt, preselectaInt ] ) => {
      this.sarlaft = sarlaftInt;
      this.listasRestrictivas = lrInt;
      this.preselecta = preselectaInt;
    } );
  }

  private setFormBusqueda() {

    this.formBusqueda = this.fb.group( {
      codigoSolicitud: [ null, [] ],
      codigoShivam: [ null, [] ],
      numeroDocumento: [ null, [] ],
      tercero: [ new Tercero() ],
      idEstructuraFisica: [ null, [] ],
      fechaInicial: [ null, [] ],
      fechaFinal: [ null, [] ],
      idTercero: [ null, [] ],
      nombreTercero: [ null, [] ]
    } );
  }

  private setFormDenegar() {
    this.formDenegarSolicitud = this.fb.group( {
      idSolicitud: [ null ],
      idCausalSolicitud: [ null, [ Validators.required ] ],
      observacion: [ null ],
      estadoRelacion: [ null ]
    } );
  }

  private getListas() {
    this.loadingCausalDlg = true;
    this.lisServicio.getMasterDetails( 'ListasCausalesSolicitudes' ).subscribe( lisCausalesSolicitud => {

      lisCausalesSolicitud.map( ( s: ListaItem ) => {
        this.listaCausalesSolicitud.push( { label: s.nombre, value: s.idLista } );
      } );

      if ( this.listaCausalesSolicitud.length === 0 ) {
        this.navService.setMesage( 4, {
          severity: 'info', summary: this.navService.buscarMensaje( 'LBL_INFORMACION' ),
          detail: this.navService.buscarMensaje( 'LISTAS.MSG_NOEXISTE' )
        } );
      }

      this.loadingCausalDlg = false;

    }, error => {
      this.navService.setMesage( 4, {
        severity: 'info', summary: this.navService.buscarMensaje( 'LBL_INFORMACION' ),
        detail: this.navService.buscarMensaje( 'LISTAS.MSG_NOEXISTE' )
      } );
      this.loadingCausalDlg = false;
    } );
  }

  private getOficinasZonas() {

    this.zonaService.getZonasConOficinas().subscribe( r => {
      if ( r && r.length > 0 ) {
        r.map( o => {
          this.listaOficinas.push( { label: o.estructura, value: o.idEstructuraFisica } );
        } );
      }
    } );
  }

  public buscar( event?: any ) {
    this.filter( event );
  }

  public setSearch() {
    this.navService.setSearch( 'solicitud-respuesta.component', this.busqueda );
  }

  public filter( event?: any ) {
    this.buscando = true;
    this.submittedBusqueda = true;
    if ( this.f.codigoSolicitud.value || this.f.codigoShivam.value || this.f.numeroDocumento.value || this.f.nombreTercero.value || this.f.idEstructuraFisica.value || this.f.fechaInicial.value || this.f.fechaFinal.value ) {
      if ( event ) {
        this.page = String( event.first / this.rowsPerPage );
      } else {
        this.page = '0';
        this.tabla.first = 0;
      }

      const a = new BusquedaFiltros();
      a.pagina = Number( this.page );
      a.cantidad = this.rowsPerPage;

      a.idEstructuraFisica = this.f.idEstructuraFisica.value ? this.f.idEstructuraFisica.value : null;
      a.codigoShivam = this.f.codigoShivam.value ? this.f.codigoShivam.value : null;
      a.numeroSolicitud = this.f.codigoSolicitud.value ? this.f.codigoSolicitud.value.toString() : null;
      a.fechaInicial = this.f.fechaInicial.value ? this.f.fechaInicial.value : null;
      a.fechaFinal = this.f.fechaFinal.value ? this.f.fechaFinal.value : null;
      a.numeroDocumento = this.f.numeroDocumento.value ? this.f.numeroDocumento.value : null;
      a.nombreTercero = this.f.nombreTercero.value ? this.f.nombreTercero.value : null;

      this.navService.setFilters( 'solicitud-bloqueo-sarlaft', 'idEstructuraFisica', this.f.idEstructuraFisica.value );
      this.navService.setFilters( 'solicitud-bloqueo-sarlaft', 'codigoShivam', this.f.codigoShivam.value );
      this.navService.setFilters( 'solicitud-bloqueo-sarlaft', 'codigoSolicitud', this.f.codigoSolicitud.value );
      this.navService.setFilters( 'solicitud-bloqueo-sarlaft', 'numeroDocumento', this.f.numeroDocumento.value );
      this.navService.setFilters( 'solicitud-bloqueo-sarlaft', 'nombreTercero', this.f.nombreTercero.value );
      this.navService.setFilters( 'solicitud-bloqueo-sarlaft', 'idTercero', this.f.idTercero.value );
      this.navService.setFilters( 'solicitud-bloqueo-sarlaft', 'fechaInicial', this.f.fechaInicial.value );
      this.navService.setFilters( 'solicitud-bloqueo-sarlaft', 'fechaFinal', this.f.fechaFinal.value );

      this.solicitudService.buscadorSolicitudesSarlaft( a ).subscribe( rta => {
        this.numRegistros = Number( rta.total );
        this.listaSolicitudesBloqueo = [];

        this.listaSolicitudesBloqueo = rta.data;
        if ( this.listaSolicitudesBloqueo.length === 0 ) {
          this.navService.setMesage( 0,
            {
              severity: 'info',
              summary: this.navService.buscarMensaje( 'LBL_INFORMACION' ),
              detail: this.navService.buscarMensaje( 'SOLICITUDRESPUESTA.MSG_NOEXISTENREGISTROS' )
            } );
        }
        this.buscando = false;
        this.submittedBusqueda = false;
      }, e => {
        this.buscando = false;
        this.submittedBusqueda = false;
        this.navService.setMesage( 0,
          {
            severity: 'error',
            summary: this.navService.buscarMensaje( 'LBL_ERROR' ),
            detail: this.navService.buscarMensaje( 'MSG_ERRORCARGAR' )
          } );

      } );
    } else {
      this.buscando = false;
      this.submittedBusqueda = false;
      this.numRegistros = null;
      this.listaSolicitudesBloqueo = [];
    }

    /*setTimeout(() => {
      this.listaSolicitudesBloqueo = this.lista;
      this.buscando = false;
      this.submittedBusqueda = false;
    }, 500);*/
  }

  limpiar() {
    this.formBusqueda.reset();
    this.navService.setFilters( 'solicitud-bloqueo-sarlaft', 'codigoShivam', this.f.codigoShivam.value );
    this.navService.setFilters( 'solicitud-bloqueo-sarlaft', 'codigoSolicitud', this.f.codigoSolicitud.value );
    this.navService.setFilters( 'solicitud-bloqueo-sarlaft', 'numeroDocumento', this.f.numeroDocumento.value );
    this.navService.setFilters( 'solicitud-bloqueo-sarlaft', 'nombreTercero', this.f.nombreTercero.value );
    this.navService.setFilters( 'solicitud-bloqueo-sarlaft', 'idEstructuraFisica', this.f.idEstructuraFisica.value );
    this.navService.setFilters( 'solicitud-bloqueo-sarlaft', 'fechaInicial', this.f.fechaInicial.value );
    this.navService.setFilters( 'solicitud-bloqueo-sarlaft', 'fechaFinal', this.f.fechaFinal.value );
    this.navService.setFilters( 'solicitud-bloqueo-sarlaft', 'idTercero', this.f.idTercero.value );
    this.listaSolicitudesBloqueo = [];
    this.numRegistros = null;
  }

  obtenerFiltros() {
    const filters = this.navService.getFilters( 'solicitud-bloqueo-sarlaft' );
    if ( filters ) {
      filters.map( ( s: any ) => {
        if ( s.value ) {
          switch ( s.filter ) {
            case 'codigoSolicitud': {
              this.f.codigoSolicitud.setValue( s.value );
              break;
            }
            case 'codigoShivam': {
              this.f.codigoShivam.setValue( s.value );
              break;
            }
            case 'numeroDocumento': {
              this.f.numeroDocumento.setValue( s.value );
              break;
            }
            case 'nombreTercero': {
              this.f.nombreTercero.setValue( s.value );
              break;
            }
            case 'idEstructuraFisica': {
              this.f.idEstructuraFisica.setValue( s.value );
              break;
            }
            case 'fechaInicial': {
              this.f.fechaInicial.setValue( s.value );
              break;
            }
            case 'fechaFinal': {
              this.f.fechaFinal.setValue( s.value );
              break;
            }
            case 'idTercero': {
              this.f.idTercero.setValue( s.value );
              break;
            }
          }
        }
      } );
    }
  }

  public buscarAutocomplete( busqueda: any, tipo: string ) {
    const dato = new BusquedaFiltros();
    if ( busqueda.query ) {
      dato.query = busqueda.query.trim().replace( /[^a-zA-ZÑñÁáÉéóÓúÚíÍ ]/gi, '' );
    }

    if ( dato.query && dato.query.length > 0 ) {
      switch ( tipo ) {
        case 'TER':
          this.terceroService.autocompleteTerceroSarlaft( dato.query ).subscribe( rta => {
            this.listaTerceros = rta;
          } );
          break;
        default:
      }
    } else {
      switch ( tipo ) {
        case 'TER':
          this.listaTerceros = [];
          break;
        default:
      }
    }
  }

  public limpiarAutocomplete( tipo: string ) {
    switch ( tipo ) {
      case 'TER':
        this.f.idTercero.setValue( null );
        this.f.nombreTercero.setValue( null );
        break;
      default:
    }
  }

  public capturar( dato: any, tipo: string ) {
    switch ( tipo ) {
      case 'TER':
        this.f.idTercero.setValue( dato.idTercero );
        this.f.nombreTercero.setValue( dato.nombreCompleto );
        break;
      default:
    }
  }

  public cambioTabView( event ) {
  }

  public continuarProceso() {
    this.confirmService.confirm( {
      message: this.navService.buscarMensaje( 'SOLICITUDBLOQUEOSARLAFT.MSG_CONTINUARPROCESO' ),
      header: this.navService.buscarMensaje( 'LBL_CONFIRMACION' ),
      icon: 'fa fa-question-circle',
      key: 'cancelar',
      accept: () => {
        this.formContinuarProcesoSarlaft.submittedContinuarProceso = true;
        // Validar que todas las unidades de credito tengan adjunto
        if ( this.validarUnidadesCredito() ) {
          this.continueProcess();
        } else {

          this.navService.setMesage( 0, {
            severity: 'info',
            summary: this.navService.buscarMensaje( 'LBL_INFORMACION' ),
            detail: this.navService.buscarMensaje( 'SOLICITUDBLOQUEOSARLAFT.MSG_FALTAADJUNTOUC' )
          } );
        }

      },
      reject: () => {
      }
    } );
  }

  private continueProcess2() {
    const estado = this.solicitudHistorico.idSolicitudEstadoHistorico;
    if ( estado ) {
      this.buscando = true;
      this.solicitudService.cambiarEstado( this.solicitudContinuaProceso.idSolicitud, estado, null, this.solicitudContinuaProceso.idFase, null, false ).subscribe( () => {
        this.solicitudContinuaProceso = null;
        this.buscando = false;
        this.guardarSolDesbloqueoSarlaft();
      } );
    } else {
      this.buscando = false;
      this.navService.setMesage( 0, {
        severity: 'info', summary: this.navService.buscarMensaje( 'LBL_ADVERTENCIA' ),
        detail: this.navService.buscarMensaje( 'SOLICITUDBLOQUEOSARLAFT.MSG_CONTROLSOLICITADONOENCONTRADO' )
      } );
    }
  }

  private continueProcess() {
    if ( this.solicitudHistorico ) {
      this.continuandoProceso = true;
      this.buscando = true;
      this.solicitudService.cambiarEstado( this.solicitudContinuaProceso.idSolicitud, this.solicitudHistorico.idSolicitudEstadoHistorico, null, this.solicitudContinuaProceso.idFase, null, false ).subscribe( () => {
        this.guardarSolDesbloqueoSarlaft();
        // INHABILITAR UC BLOQUEO
        this.solUcBloqueo.indicadorHabilitado = false;
        this.solUcBloqueoService.actualizar( this.solUcBloqueo ).subscribe();
        // this.solUcBloqueoService.inhabilitarPorIdSolUcYResultadoIntegracion(this.solicitudContinuaProceso.idSolicitudUnidadCredito, this.solicitudContinuaProceso.integracionObj.idResultadoIntegracion).subscribe();
        this.cenRiesgoIntegracionServicio.lanzarIntegraciones( this.solicitudContinuaProceso.idSolicitud, this.authService.obtenerIdUsuarioLogueado() ).subscribe( response => {
          this.intValidatorService.validarIntegracion( this.solicitudContinuaProceso.idSolicitud, null ).subscribe( valid => {
            if ( valid && valid.length > 0 ) {
              // HAY BLOQUEO DESPUES DE LAS INTEGRACIONES
              this.buscando = false;
              this.limpiarModeloContinuarProceso();
              this.limpiarModeloDenegarSolicitud();
              this.showDlgDenegar = false;
              this.solicitudHistorico = null;
              this.filter();
              this.intValidatorService.mostrarMensajePorBloqueoIntegracion( valid[ 0 ] );
            } else {
              // VERIFICAR SI SE LANZA PRESELECTA
              if ( this.preselecta.indicadorEncendido ) {
                this.politicaCreditoService.validarPreSelecta( this.solicitudContinuaProceso.idSolicitud ).subscribe( bloqueados => {
                  if ( bloqueados ) {
                    this.intValidatorService.validarIntegracion( this.solicitudContinuaProceso.idSolicitud, Integraciones.PRESELECTA, bloqueados ).subscribe( r => {
                      this.buscando = false;
                      this.limpiarModeloContinuarProceso();
                      this.limpiarModeloDenegarSolicitud();
                      this.showDlgDenegar = false;
                      this.solicitudHistorico = null;
                      this.filter();
                      if ( r && r.length > 0 ) {
                        // HAY BLOQUEO POR PRESELECTA
                        this.intValidatorService.mostrarMensajePorBloqueoIntegracion( r[ 0 ] );
                      } else {
                        // NO HAY BLOQUEOS POR PRESELECTA, DESBLOQUEO EXITOSO - CASO IDEAL
                        this.navService.setMesage( 0, {
                          severity: 'info', summary: this.navService.buscarMensaje( 'LBL_INFORMACION' ),
                          detail: this.navService.buscarMensaje( 'SOLICITUDBLOQUEOSARLAFT.MSG_CAMBIOESTADOEXITOSO' )
                        } );
                      }
                    } );
                  }
                } );
              } else {
                // NO SE LANZA PRESELECTA POR INDICADOR APAGADO, DESBLOQUEO EXITOSO
                this.buscando = false;
                this.limpiarModeloContinuarProceso();
                this.limpiarModeloDenegarSolicitud();
                this.showDlgDenegar = false;
                this.solicitudHistorico = null;
                this.filter();
                this.navService.setMesage( 0, {
                  severity: 'info', summary: this.navService.buscarMensaje( 'LBL_INFORMACION' ),
                  detail: this.navService.buscarMensaje( 'SOLICITUDBLOQUEOSARLAFT.MSG_CAMBIOESTADOEXITOSO' )
                } );
              }
            }
          } );
        }, e => {
          console.log( e );
          this.buscando = false;
          this.continuandoProceso = false;
        } );
      } );
    } else {
      // NO HAY HISTORICO PARA REALIZAR EL CAMBIO ESTADO - REVISAR LA LISTA DE ESTADOS DE LA SOLICITUD EN CUESTION
      this.buscando = false;
      this.continuandoProceso = false;

      this.navService.setMesage( 0, {
        severity: 'info', summary: this.navService.buscarMensaje( 'LBL_INFORMACION' ),
        detail: this.navService.buscarMensaje( 'SOLICITUDBLOQUEOSARLAFT.MSG_ERRORHISTORICOESTADOS' )
      } );
    }
  }

  private gestionarSolicitud( data ) {
    this.cargandoInfoSolicitud = true;
    // this.formContinuarProcesoSarlaft.listaUnidadesCredito = Object.assign( [], this.unidadesCredito );
    this.formContinuarProcesoSarlaft.idSolicitud = data.idSolicitud;
    this.solicitudContinuaProceso = data;
    this.solUcBloqueo = null;

    forkJoin(
      // this.solUcService.obtenerPorIdSolicitudBloqueoSarlaft( data.idSolicitud ),
      this.solUcBloqueoService.obtenerUCPorSolicitud( data.idSolicitud ),
      this.proEstadoRelacionServicio.listadoPorProductoYEstado( data.idProducto, data.idEstado ),
      this.solEstadoHistoricoService.listadoPorSolicitud( data.idSolicitud ) ).subscribe( ( [ uscSarlaft, proEstadoRelacion, res ] ) => {
      if ( uscSarlaft && uscSarlaft.length > 0 ) {
        this.solUcBloqueo = uscSarlaft[ 0 ];

        uscSarlaft.map( ucs => {
          this.solUcService.obtenerIndicadorEstadoActivo( ucs.idSolicitudUnidadCredito ).subscribe( data => {
            ucs.idAdjunto = null;
            ucs.nomArchivo = null;
            ucs.observacion = null;
            ucs.integracionObj = JSON.parse( ucs.respuestaIntegracion );
            if ( data.idAdjunto ) {
              this.adjServicio.descargarArchivo( data.idAdjunto ).subscribe( res => {
                const blob = URL.createObjectURL( res );
                ucs.rutaAdjuntoRiesgo = this.sanitizer.bypassSecurityTrustResourceUrl( blob );
              } );
            }
          } );

          console.log( ucs );
          this.formContinuarProcesoSarlaft.listaUnidadesCredito.push( ucs );
        } );
      }

      this.lstProductoEstado = proEstadoRelacion;

      if ( res ) {
        this.solicitudHistoricos = res;
        if ( ( res.length - 1 ) > 0 ) {
          this.solicitudHistorico = res[ ( res.length - 1 ) - 1 ];
        }
        this.cargandoInfoSolicitud = false;
        this.formContinuarProcesoSarlaft.showDlgContinuarProceso = true;
      } else {
        this.cargandoInfoSolicitud = false;
        this.formContinuarProcesoSarlaft.showDlgContinuarProceso = true;
      }

    }, e => {
      console.log( e );
      this.cargandoInfoSolicitud = false;
    } );
  }

  private validarUnidadesCredito(): boolean {
    let sinAdjuntos = this.formContinuarProcesoSarlaft.listaUnidadesCredito.filter( x => x.idAdjunto === null );

    if ( sinAdjuntos.length > 0 ) {
      return false;
    } else {
      return true;
    }
  }

  public abrirModalDenegar() {

    this.formDenegarSolicitud = this.fb.group( {
      idSolicitud: [ this.solicitudContinuaProceso.idSolicitud ],
      idCausalSolicitud: [ null, [ Validators.required ] ],
      observacion: [ null ],
      estadoRelacion: [ null ]
    } );

    if ( this.lstProductoEstado.length > 0 ) {
      this.loadingCausalDlg = true;
      const estado: ProductoEstadoRelacion = this.lstProductoEstado.find( x => x.codigoFuncionalidadHijo == 'BTNDENEGADO' && x.codigoFuncionalidadPadre == 'SARLAFT' );

      if ( estado ) {
        this.proEstadoRelacionCausalServicio.listadoPorProductoEstadoRelacion( estado.idProductoEstadoRelacion ).subscribe( response => {
          this.fD.estadoRelacion.setValue( estado );
          response.map( ( s ) => {
            this.listaCausalesSolicitud.push( { label: s.nombreCausal, value: s.idCausal } );
          } );

          this.loadingCausalDlg = false;
          this.showDlgDenegar = true;
        } );
      } else {
        this.loadingCausalDlg = false;
        this.navService.setMesage( 0, {
          severity: 'info', summary: this.navService.buscarMensaje( 'LBL_ADVERTENCIA' ),
          detail: this.navService.buscarMensaje( 'SOLICITUDBLOQUEOSARLAFT.MSG_CONTROLSOLICITADONOENCONTRADO' )
        } );
      }

    } else {
      this.navService.setMesage( 0, {
        severity: 'info', summary: this.navService.buscarMensaje( 'LBL_ADVERTENCIA' ),
        detail: this.navService.buscarMensaje( 'SOLICITUDBLOQUEOSARLAFT.MSG_NOLISTARELACION' )
      } );
    }
  }

  public cerrarDlgGestionarSarlaft() {
    this.limpiarModeloContinuarProceso();
    this.limpiarModeloDenegarSolicitud();
    this.solicitudHistorico = null;
    this.solicitudHistoricos = [];
  }

  private limpiarModeloContinuarProceso() {
    this.formContinuarProcesoSarlaft = {
      listaUnidadesCredito: [],
      idSolicitud: null,
      submittedContinuarProceso: false,
      showDlgContinuarProceso: false,
      uploadingFile: false
    };
  }

  private limpiarModeloDenegarSolicitud() {
    this.formDenegarSolicitud.reset();
  }

  public eliminarAdjunto( ucIndex: number ) {
    this.formContinuarProcesoSarlaft.listaUnidadesCredito[ ucIndex ].idAdjunto = null;
    this.formContinuarProcesoSarlaft.listaUnidadesCredito[ ucIndex ].nomArchivo = null;
  }


  public onBeforeSend( event: any, ucIndex: number ) {
    this.formContinuarProcesoSarlaft.uploadingFile = true;
    this.adjServicio.cargarArchivo( event, this.formContinuarProcesoSarlaft.listaUnidadesCredito[ ucIndex ].nomArchivo, 'Alerta' );
  }

  public onUpload( event: any, ucIndex: number ) {
    const respuesta = event.originalEvent.body
    if ( respuesta.idAdjunto != null || respuesta.idAdjunto !== undefined ) {
      this.formContinuarProcesoSarlaft.listaUnidadesCredito[ ucIndex ].idAdjunto = respuesta.idAdjunto;
      this.formContinuarProcesoSarlaft.uploadingFile = false;
    } else {
      this.formContinuarProcesoSarlaft.listaUnidadesCredito[ ucIndex ].idAdjunto = null;
      this.formContinuarProcesoSarlaft.listaUnidadesCredito[ ucIndex ].nomArchivo = null;
      this.formContinuarProcesoSarlaft.uploadingFile = false;
    }
  }

  public onSelect( event: any, file: any, ucIndex: number ) {
    this.formContinuarProcesoSarlaft.listaUnidadesCredito[ ucIndex ].nomArchivo = file[ 0 ].name;
  }

  public preguntarDenegarSolicitud() {
    // console.log("denegando");
    this.confirmService.confirm( {
      message: this.navService.buscarMensaje( 'SOLICITUDBLOQUEOSARLAFT.MSG_DENEGARSOLICITUD' ),
      header: this.navService.buscarMensaje( 'LBL_CONFIRMACION' ),
      icon: 'fa fa-question-circle',
      key: 'cancelar',
      accept: () => {
        this.denegarSubmitted = true;
        if ( this.formDenegarSolicitud.valid ) {
          this.denegarSolicitud();
        }
      },
      reject: () => {
        this.denegarSubmitted = false;
      }
    } );
  }

  public denegarSolicitud() {
    /*console.log(this.solicitudHistorico);
    console.log(this.fD);*/
    this.savingCausal = true;
    this.buscando = true;
    this.solicitudService.cambiarEstado( this.solicitudHistorico.idSolicitudEstadoHistorico, this.fD.estadoRelacion.value.idEstado, this.fD.idCausalSolicitud.value, this.fD.estadoRelacion.value.indicadorMantieneFase ? this.solicitudHistorico.idFase : this.fD.estadoRelacion.value.idFase, this.fD.observacion.value, false ).subscribe( () => {
      this.buscando = false;
      // this.filter( { first: this.obtenerPagina( Number( this.page ) ) } );
      this.filter();
      this.solicitudHistorico = null;
      this.limpiarModeloDenegarSolicitud();
      this.limpiarModeloContinuarProceso();
      this.showDlgDenegar = false;
      this.savingCausal = false;

    } );
  }


  cancelarDenegar( dirty: boolean ) {
    this.denegarSubmitted = false;
    if ( dirty ) {
      this.confirmService.confirm( {
        message: this.navService.buscarMensaje( 'MSG_CANCELARCAMBIOS' ),
        header: this.navService.buscarMensaje( 'LBL_CONFIRMACION' ),
        icon: 'fa fa-question-circle',
        accept: () => {
          this.showDlgDenegar = false;
          this.limpiarModeloDenegarSolicitud();
        },
        reject: () => {
        }
      } );
    } else {
      this.showDlgDenegar = false;
      this.limpiarModeloDenegarSolicitud();
    }
  }

  private obtenerPagina( pagina: number ) {
    const valTotal = pagina * 10;
    if ( this.listaSolicitudesBloqueo.length === 1 && valTotal > 0 ) {
      const nueValor = ( valTotal - 10 );
      this.tabla.first = nueValor;
      return nueValor;
    } else {
      return valTotal;
    }
  }

  private guardarSolDesbloqueoSarlaft() {
    const desbloqueoGuardar = {
      idSolicitudUCDesbloqueo: null,
      idSolicitudUnidadCredito: this.formContinuarProcesoSarlaft.listaUnidadesCredito[0].idSolicitudUnidadCredito,
      idAdjunto: this.formContinuarProcesoSarlaft.listaUnidadesCredito[0].idAdjunto,
      observacion: this.formContinuarProcesoSarlaft.listaUnidadesCredito[0].observacion,
      auditoriaFecha: null,
      auditoriaUsuario: this.authService.obtenerIdUsuarioLogueado(),
      indicadorHabilitado: true,
      idSolicitudUCBloqueo: this.solUcBloqueo.idSolicitudUCBloqueo
    } as SolicitudUcDesbloqueo;

    this.solUcDesbloqueoSarlaftService.crear( desbloqueoGuardar ).subscribe();
  }
}
